import React from 'react';

const CopyIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24">
    <path d="M17 1v1h4v16h-4v4H3V6h4V2h4V1h6zM7 8H5v12h10v-2H7V8zm4-4H9v12h10V4h-2v1h-6V4z" />
  </svg>
);

export default CopyIcon;
